import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "absolute",
    left: 16,
    right: 16,
    top: 32,
    zIndex: theme.zIndex.dialog,
  },
  noti: {
    background: theme.colors.Background3,
  },
  forwardsAnimate: {
    animation: `$forwardsAnimate 0.3s ease-in both`,
    overflow: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  backwardsAnimate: {
    animation: `$backwardsAnimate 0.3s ease-in`,
    overflow: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  "@keyframes forwardsAnimate": {
    "0%": {
      transform: "translateY(-100%)",
    },
    "100%": {
      transform: "translateY(0%)",
    },
  },
  "@keyframes backwardsAnimate": {
    "0%": {
      transform: "translateY(0%)",
    },
    "100%": {
      transform: "translateY(-100%)",
    },
  },
}));
